import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const L12M = styled.p`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  ${customTextColor}
`;
